export const ALIGNS_CONTENT = ['Left', 'Right', 'Center']
